/* eslint-disable no-unused-vars */
import axios from "axios";

// Declare global constants for the build environment
declare const __API_BASE_URL__: string;
declare const __APP_VERSION__: string;
declare const __APP_COPYRIGHT__: string;

export const getUser_old = () => {
  const userStr = localStorage.getItem("user");
  if (userStr) return JSON.parse(userStr);
  else return null;
};
export const getUserData = () => {
  const userStr = localStorage.getItem("userData");
  if (userStr) return JSON.parse(userStr);
  else return null;
};

export const getToken_old = () => {
  return localStorage.getItem("token") || null;
};

export const getTokenX = () => {
  return localStorage.getItem("tokenX") || null;
};

/* export const setEmailName = (emailName) => {
  //localStorage.setItem("emailName", JSON.stringify(emailName));
}; */

export const timeAgo = (dateString: string) => {
  const date = new Date(dateString);
  const now = new Date();
  const seconds = Math.floor((now.getTime() - date.getTime()) / 1000);

  if (seconds < 5) return 'just now';

  const intervals = {
    year: 31536000,
    month: 2592000,
    day: 86400,
    hour: 3600,
    minute: 60
  };

  for (const [unit, value] of Object.entries(intervals)) {
    const count = Math.floor(seconds / value);
    if (count >= 1) {
      return count === 1 ? `1 ${unit} ago` : `${count} ${unit}s ago`;
    }
  }

  return 'just now';
};


export const getEmailName = () => {
  const emailName = localStorage.getItem("emailName");
  if (emailName) return JSON.parse(emailName);
  else return null;
};


// common/utils.ts
 

export const getToken = () => {
  const token = localStorage.getItem('userToken');
  console.log('Getting token:', token); // Debug log
  return token;
};

export const getUser = () => {
  const userData = localStorage.getItem('userData');
  return userData ? JSON.parse(userData) : null;
};

 


export const setUserSession = (token, user) => {
    localStorage.setItem('userToken', token);
  localStorage.setItem("token", token);
  localStorage.setItem("user", JSON.stringify(user));
  localStorage.setItem("userData", JSON.stringify(user));
  localStorage.setItem("appSettings", JSON.stringify(user.accessPin));
  localStorage.setItem("emailName", JSON.stringify(user.schoolName));

   
  // Force a storage event for cross-tab sync (and for our listeners)
  window.dispatchEvent(new Event('storage'));


  // localStorage.setItem("tokenX", user.token);

  //   localStorage.setItem("submenuList", submenu);
  //   localStorage.setItem("mainmenulist", mainmenu);
};

export const removeShopDet = () => {
  localStorage.removeItem("shopDet");
};

export const logOutUser = () => {
 removeUserSession();
  localStorage.removeItem('userToken');
  localStorage.removeItem('userData');
  window.dispatchEvent(new Event('storage'))

};
export const removeUserSession = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("user");
  localStorage.removeItem("tokenX");
  localStorage.removeItem("list");
  localStorage.removeItem("usersList");
  localStorage.removeItem("userData");
  localStorage.removeItem("appSettings");
  localStorage.removeItem("categoryList");
  localStorage.removeItem("shopProducts");
  localStorage.removeItem("shopList");
  localStorage.removeItem("shopNumber");
  localStorage.removeItem("categoryNumber");
  localStorage.removeItem("businessData");
window.location.reload();
};


//cookie.set("onboarded", true, {path: "/", expires: d});

export const requestID = () => {
  return "rid_12345678903";
  return "rid_12345678902";
  // return "rid_123456";
};

export const biometricCode = () => {
  return "www.appstack.ng";
  // return "rid_123456";
};


//export const  baseURL = "https://beninclub1931apps.ng/"
//"https://192.168.194.100/beninclubapi/"

//return "https://192.168.194.100/beninclubapi/"
//export const  baseURL = "https://192.168.194.100/beninclubapi/"

// export const baseUrl = () => {
//   //return 'https://api.kademic5.com.ng/testapi/users/login/0'
//   // return "https://192.168.234.143/zillyapi/";
// //return "https://rmfwarriapi.kademic5.com.ng/";
// //return "https://appstack.ng/api/";
// //return "http://deltashtportal.kademic.com.ng/api/"
// //return "https://beninclub1931apps.com.ng/";

//   //return "https://rmfwarriapi.kademic5.com.ng/";
// return __API_BASE_URL__
//  //return "https://beninclubgolfapi.kademic5.com.ng/api/production/v1/";
//  //return "https://beninclubgolfapi.kademic5.com.ng/api/development/v1/";

//   //return "http://192.168.194.100/beninclubapi/"
// //    return "http://208.115.219.94/~beninclu/bar/";
// //return "https://beninclub1931apps.ng/";
// //return "https://192.168.194.100/beninclubapi/"


// };
export const baseUrl = (): string => {
  return __API_BASE_URL__;
};
export const baseUrl3 = (): string => {
  return "https://beninclub1931apps.ng/api/";
};

export const APP_VERSION = __APP_VERSION__;


export const APP_COPYRIGHT = __APP_COPYRIGHT__;
export const formatDateForAPI = (date: Date): string => {
  return date.toISOString().split("T")[0];
};

export const baseURL = baseUrl();

export const baseUrl2 = () => {
  return baseUrl();
  // "https://beninclubgolfapi.kademic5.com.ng/Businesss/addBusiness";
};
export const profileImgUrl =

  baseUrl() + "assets/img/user/";

export const setUsersList = (list) => {
  localStorage.setItem("usersList", JSON.stringify(list));
};

export const setList = (listn) => {
  localStorage.setItem("list", JSON.stringify(listn));
};

export const setSmList = (listx) => {
  localStorage.setItem("setsubmoduleList", JSON.stringify(listx));
};

/*  export const removeUsersList = () => {
        localStorage.removeItem("usersList");
        } */
export const getUsersList = () => {
  const listDataxn = localStorage.getItem("usersList");
  if (listDataxn) return JSON.parse(listDataxn);
  else return null;
};

export const getSmList = () => {
  //return localStorage.getItem("list") || null;
  const listDatax = localStorage.getItem("setsubmoduleList");
  if (listDatax) return JSON.parse(listDatax);
  else return null;
};

export const getAppSettings = () => {
  //return localStorage.getItem("list") || null;
  const appSettings = localStorage.getItem("appSettings");
  if (appSettings) return JSON.parse(appSettings);
  else return null;
};

export const setAppSettings = (appSettings) => {
  localStorage.setItem("appSettings", JSON.stringify(appSettings));
};

export const getList = () => {
  //return localStorage.getItem("list") || null;
  const listData = localStorage.getItem("list");
  if (listData) return JSON.parse(listData);
  else return null;
};
export const setUserData = (user) => {
  localStorage.setItem("userData", JSON.stringify(user));
};
// export const setUserData = (user) => {
//   localStorage.setItem("userData", JSON.stringify(user));
// };
export const configFileUpload = {
  headers: {
    Authorization: `Bearer ${getToken()}`,
    Accept: "application/json", // expect JSON back
    "Content-type": "multipart/form-data",

    // ⚠️ Don't add Content-Type, let Axios handle it
  },
};


export const config = {
  headers: {
    Authorization: `Bearer ${getToken()}`,
    "Content-Type": "application/json",
    "Content-type": "multipart/form-data",
  },
};

export const configEx = {
  headers: {
    // Authorization: `Basic ${getToken()}`,
    "content-type": "multipart/form-data",
    "Access-Control-Allow-Origin": true,
    auth: {
      username: "MDc4YjQ4YTVjNjQ0NDJkZGI2M2FjM2QxZjA2MDQxNTM=",
      password: "cyber@123=",
    },
  },
};

// const [showToast, setShowToast] = useState(false);
export const callToast = (setShowToast) => {
  setShowToast(true);
  setTimeout(() => setShowToast(false), 1500);
};

export const setCategoryList = (list) => {
  localStorage.setItem("categoryList", JSON.stringify(list));
};

export const setBusinessData = (list) => {
  localStorage.setItem("businessData", JSON.stringify(list));
};
export const setShopDet = (list) => {
  localStorage.setItem("shopDet", JSON.stringify(list));
};
export const setCategoryNumber = (list) => {
  localStorage.setItem("categoryNumber", JSON.stringify(list));
};

export const setShopDetails = (list) => {
  localStorage.setItem("shopDetails", JSON.stringify(list));
};

export const getShopDetails = () => {
  const listDataxn = localStorage.getItem("shopDetails");
  if (listDataxn) return JSON.parse(listDataxn);
  else return null;
};

export const getshopDet = () => {
  const listDataxn = localStorage.getItem("setShopDet");
  if (listDataxn) return JSON.parse(listDataxn);
  else return null;
};

export const setShopList = (list) => {
  localStorage.setItem("shopList", JSON.stringify(list));
};

export const setShopNumber = (list) => {
  localStorage.setItem("shopNumber", JSON.stringify(list));
};

export const getCategoryList = () => {
  const listDataxn = localStorage.getItem("categoryList");
  if (listDataxn) return JSON.parse(listDataxn);
  else return null;
};


export const getCategoryNumber = () => {
  const listDataxn = localStorage.getItem("categoryNumber");
  if (listDataxn) return JSON.parse(listDataxn);
  else return null;
};
export const getBusinessData = () => {
  const listDataxn = localStorage.getItem("businessData");
  if (listDataxn) return JSON.parse(listDataxn);
  else return null;
};


export const getShopList = () => {
  const listDataxn = localStorage.getItem("shopList");
  if (listDataxn) return JSON.parse(listDataxn);
  else return null;
};
export const getShopNumber = () => {
  const listDataxn = localStorage.getItem("shopNumber");
  if (listDataxn) return JSON.parse(listDataxn);
  else return null;
};
export const getShopProducts = () => {
  const listDataxn = localStorage.getItem("shopProducts");
  if (listDataxn) return JSON.parse(listDataxn);
  else return null;
};
export const setShopProducts = (list) => {
  localStorage.setItem("shopProducts", JSON.stringify(list));
};

// TokenUtils.ts
const SECRET_KEY = 'myUltraSecretKey';
const CODE_LENGTH = 6;

export const EXPIRATION_RULES = {
  '1min': 30,
  '2min': 120,
  '5min': 300,
  '30min': 1800,
  '1hr': 3600,
};

function strToBuffer(str: string) {
  return new TextEncoder().encode(str);
}

async function getKey(secret: string) {
  return crypto.subtle.importKey(
    'raw',
    strToBuffer(secret),
    { name: 'HMAC', hash: 'SHA-256' },
    false,
    ['sign']
  );
}

export function formatDate(dateInput: Date | string): string {
  const date = new Date(dateInput);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}

export const calculateDaysBetween = (
  start: Date | string,
  end: Date | string
): number => {
  const startDate = new Date(start);
  const endDate = new Date(end);

  if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) {
    console.warn(
      "Invalid date(s) provided to calculateDaysBetween:",
      start,
      end
    );
    return 0;
  }

  const diffTime = Math.abs(endDate.getTime() - startDate.getTime());
  return Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1;
};


// export
export async function generateToken(memberId: string | number, expirationType: keyof typeof EXPIRATION_RULES) {
  const timestamp = Math.floor(Date.now() / 1000 / 30); // round to nearest 30s
  const data = `${memberId}|${expirationType}|${timestamp}`;
  const key = await getKey(SECRET_KEY);
  const hmac = await crypto.subtle.sign('HMAC', key, strToBuffer(data));
  const hash = new Uint8Array(hmac).slice(0, 4);
  const number = (hash[0] << 24) | (hash[1] << 16) | (hash[2] << 8) | hash[3];
  const token = Math.abs(number % 1000000).toString().padStart(CODE_LENGTH, '0');
  return token;
}

export async function verifyToken(token: string, memberId: string | number, expirationType: keyof typeof EXPIRATION_RULES) {
  const now = Math.floor(Date.now() / 1000);
  const validFor = EXPIRATION_RULES[expirationType];
  const timeWindow = 30;

  for (let t = 0; t <= validFor; t += timeWindow) {
    const ts = Math.floor((now - t) / timeWindow);
    const data = `${memberId}|${expirationType}|${ts}`;
    const key = await getKey(SECRET_KEY);
    const hmac = await crypto.subtle.sign('HMAC', key, strToBuffer(data));
    const hash = new Uint8Array(hmac).slice(0, 4);
    const number = (hash[0] << 24) | (hash[1] << 16) | (hash[2] << 8) | hash[3];
    const expected = Math.abs(number % 1000000).toString().padStart(CODE_LENGTH, '0');

    if (token === expected) {
      return { valid: true, memberId };
    }
  }

  return { valid: false };
}
